// source: type/compensation_claim.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var type_compensation_pb = require('../type/compensation_pb.js');
goog.object.extend(proto, type_compensation_pb);
goog.exportSymbol('proto.type.CompensationClaim', null, global);
goog.exportSymbol('proto.type.CompensationClaim.CompensationCase', null, global);
goog.exportSymbol('proto.type.CompensationClaim.Reason', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.CompensationClaim = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.CompensationClaim.oneofGroups_);
};
goog.inherits(proto.type.CompensationClaim, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.CompensationClaim.displayName = 'proto.type.CompensationClaim';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.CompensationClaim.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.type.CompensationClaim.CompensationCase = {
  COMPENSATION_NOT_SET: 0,
  EXCHANGE: 1,
  RETURNS: 2,
  DISCOUNT: 3,
  OTHER: 4
};

/**
 * @return {proto.type.CompensationClaim.CompensationCase}
 */
proto.type.CompensationClaim.prototype.getCompensationCase = function() {
  return /** @type {proto.type.CompensationClaim.CompensationCase} */(jspb.Message.computeOneofCase(this, proto.type.CompensationClaim.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.CompensationClaim.prototype.toObject = function(opt_includeInstance) {
  return proto.type.CompensationClaim.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.CompensationClaim} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.CompensationClaim.toObject = function(includeInstance, msg) {
  var f, obj = {
    exchange: (f = msg.getExchange()) && type_compensation_pb.Compensation.Exchange.toObject(includeInstance, f),
    returns: (f = msg.getReturns()) && type_compensation_pb.Compensation.Returns.toObject(includeInstance, f),
    discount: (f = msg.getDiscount()) && type_compensation_pb.Compensation.Discount.toObject(includeInstance, f),
    other: (f = msg.getOther()) && type_compensation_pb.Compensation.Other.toObject(includeInstance, f),
    reason: jspb.Message.getFieldWithDefault(msg, 5, 0),
    compensationDetail: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of CompensationClaim as accepted by the `fromObject` method.
 * @record
 */
proto.type.CompensationClaim.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.exchange;

  /** @type {?|undefined} */
  this.returns;

  /** @type {?|undefined} */
  this.discount;

  /** @type {?|undefined} */
  this.other;

  /** @type {?|undefined} */
  this.reason;

  /** @type {?|undefined} */
  this.compensationDetail;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.CompensationClaim.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.CompensationClaim}
 */
proto.type.CompensationClaim.fromObject = function(obj) {
  var msg = new proto.type.CompensationClaim();
  obj.exchange && jspb.Message.setWrapperField(
      msg, 1, type_compensation_pb.Compensation.Exchange.fromObject(obj.exchange));
  obj.returns && jspb.Message.setWrapperField(
      msg, 2, type_compensation_pb.Compensation.Returns.fromObject(obj.returns));
  obj.discount && jspb.Message.setWrapperField(
      msg, 3, type_compensation_pb.Compensation.Discount.fromObject(obj.discount));
  obj.other && jspb.Message.setWrapperField(
      msg, 4, type_compensation_pb.Compensation.Other.fromObject(obj.other));
  obj.reason != null && jspb.Message.setField(msg, 5, obj.reason);
  obj.compensationDetail != null && jspb.Message.setField(msg, 6, obj.compensationDetail);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.CompensationClaim}
 */
proto.type.CompensationClaim.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.CompensationClaim;
  return proto.type.CompensationClaim.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.CompensationClaim} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.CompensationClaim}
 */
proto.type.CompensationClaim.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_compensation_pb.Compensation.Exchange;
      reader.readMessage(value,type_compensation_pb.Compensation.Exchange.deserializeBinaryFromReader);
      msg.setExchange(value);
      break;
    case 2:
      var value = new type_compensation_pb.Compensation.Returns;
      reader.readMessage(value,type_compensation_pb.Compensation.Returns.deserializeBinaryFromReader);
      msg.setReturns(value);
      break;
    case 3:
      var value = new type_compensation_pb.Compensation.Discount;
      reader.readMessage(value,type_compensation_pb.Compensation.Discount.deserializeBinaryFromReader);
      msg.setDiscount(value);
      break;
    case 4:
      var value = new type_compensation_pb.Compensation.Other;
      reader.readMessage(value,type_compensation_pb.Compensation.Other.deserializeBinaryFromReader);
      msg.setOther(value);
      break;
    case 5:
      var value = /** @type {!proto.type.CompensationClaim.Reason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompensationDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.CompensationClaim.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.CompensationClaim.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.CompensationClaim} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.CompensationClaim.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      type_compensation_pb.Compensation.Exchange.serializeBinaryToWriter
    );
  }
  f = message.getReturns();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      type_compensation_pb.Compensation.Returns.serializeBinaryToWriter
    );
  }
  f = message.getDiscount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      type_compensation_pb.Compensation.Discount.serializeBinaryToWriter
    );
  }
  f = message.getOther();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      type_compensation_pb.Compensation.Other.serializeBinaryToWriter
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCompensationDetail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.type.CompensationClaim.Reason = {
  REASON_UNSPECIFIED: 0,
  CORRUPTION: 1,
  QUALITY_COMPLAINT: 2,
  PICKING_ERROR: 3,
  MISDELIVERY: 4,
  NOTATION_ERROR: 5,
  EXPIRATION_DATE_EXPIRED: 6,
  CUSTOMER_REASON: 7,
  OTHERS: 8
};

/**
 * optional Compensation.Exchange exchange = 1;
 * @return {?proto.type.Compensation.Exchange}
 */
proto.type.CompensationClaim.prototype.getExchange = function() {
  return /** @type{?proto.type.Compensation.Exchange} */ (
    jspb.Message.getWrapperField(this, type_compensation_pb.Compensation.Exchange, 1));
};


/**
 * @param {?proto.type.Compensation.Exchange|undefined} value
 * @return {!proto.type.CompensationClaim} returns this
*/
proto.type.CompensationClaim.prototype.setExchange = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.CompensationClaim.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.clearExchange = function() {
  return this.setExchange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.CompensationClaim.prototype.hasExchange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Compensation.Returns returns = 2;
 * @return {?proto.type.Compensation.Returns}
 */
proto.type.CompensationClaim.prototype.getReturns = function() {
  return /** @type{?proto.type.Compensation.Returns} */ (
    jspb.Message.getWrapperField(this, type_compensation_pb.Compensation.Returns, 2));
};


/**
 * @param {?proto.type.Compensation.Returns|undefined} value
 * @return {!proto.type.CompensationClaim} returns this
*/
proto.type.CompensationClaim.prototype.setReturns = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.CompensationClaim.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.clearReturns = function() {
  return this.setReturns(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.CompensationClaim.prototype.hasReturns = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Compensation.Discount discount = 3;
 * @return {?proto.type.Compensation.Discount}
 */
proto.type.CompensationClaim.prototype.getDiscount = function() {
  return /** @type{?proto.type.Compensation.Discount} */ (
    jspb.Message.getWrapperField(this, type_compensation_pb.Compensation.Discount, 3));
};


/**
 * @param {?proto.type.Compensation.Discount|undefined} value
 * @return {!proto.type.CompensationClaim} returns this
*/
proto.type.CompensationClaim.prototype.setDiscount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.CompensationClaim.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.clearDiscount = function() {
  return this.setDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.CompensationClaim.prototype.hasDiscount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Compensation.Other other = 4;
 * @return {?proto.type.Compensation.Other}
 */
proto.type.CompensationClaim.prototype.getOther = function() {
  return /** @type{?proto.type.Compensation.Other} */ (
    jspb.Message.getWrapperField(this, type_compensation_pb.Compensation.Other, 4));
};


/**
 * @param {?proto.type.Compensation.Other|undefined} value
 * @return {!proto.type.CompensationClaim} returns this
*/
proto.type.CompensationClaim.prototype.setOther = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.type.CompensationClaim.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.clearOther = function() {
  return this.setOther(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.CompensationClaim.prototype.hasOther = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Reason reason = 5;
 * @return {!proto.type.CompensationClaim.Reason}
 */
proto.type.CompensationClaim.prototype.getReason = function() {
  return /** @type {!proto.type.CompensationClaim.Reason} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.type.CompensationClaim.Reason} value
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string compensation_detail = 6;
 * @return {string}
 */
proto.type.CompensationClaim.prototype.getCompensationDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.CompensationClaim} returns this
 */
proto.type.CompensationClaim.prototype.setCompensationDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


goog.object.extend(exports, proto.type);
